import React from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';

function CouponDetail() {
    useAuthGuard();

    return (
        <Layout>

            Coupon

        </Layout>
    );
}

export default CouponDetail;
